import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Accordion } from 'react-bootstrap';

function Questions() {
    const [open, setOpen] = useState(false);

    return (
        <section className="faq">
            <div className="container">
                <div className="heading">
                    Popular questions
                </div>
                <div className="short-desc">
                    We have collected frequently asked questions and hope that you will find the answer you need here. If not, write to us and we will be happy to advise you.
                </div>

                <Accordion>


                    <Accordion.Item eventKey="0">
                        <Accordion.Header>Can you guarantee my anonymity?</Accordion.Header>
                    
                        <Accordion.Body>
                            We respect the right to privacy and offer different levels of anonymity depending on the client's personal preferences.
                        </Accordion.Body>
                    </Accordion.Item>


                    <Accordion.Item eventKey="1">
                        <Accordion.Header>
                            Do I need to create explicit content to succeed on Onlyfans?
                        </Accordion.Header>
                    
                        <Accordion.Body>
                            We support content in all its forms and types. Your success on Onlyfans depends only on the quality and uniqueness of the content, not on its frankness.
                        </Accordion.Body>
                    </Accordion.Item>


                    <Accordion.Item eventKey="2">
                        <Accordion.Header>
                            What support will I get from your marketing agency?
                        </Accordion.Header>
                        
                        <Accordion.Body>
                            We offer personal support 24/7. We will provide management of your social media pages, interaction with followers and even strategic planning.
                        </Accordion.Body>
                    </Accordion.Item>


                    <Accordion.Item eventKey="3">
                        <Accordion.Header>
                            How do you help with content creation?
                        </Accordion.Header>
                        
                        <Accordion.Body>
                            A team of experts works to create unique and interesting content ideas, assist in its production, control quality and perform many other tasks.
                        </Accordion.Body>
                    </Accordion.Item>


                    <Accordion.Item eventKey="4">
                        <Accordion.Header>
                            What percentage does the agency get?
                        </Accordion.Header>
                        
                        <Accordion.Body>
                            The terms of cooperation are discussed individually with each model. The cost of the agency's services may be affected by such factors as presence in social networks, the number of subscribers and even current income.
                        </Accordion.Body>
                    </Accordion.Item>


                </Accordion>

            </div>
        </section>
    );
}

export default Questions;